<template>
	<div style="height: 100vh;">
		<div class="initers">
			<div class="initslogos">
				<img src="https://www.hngtsd.net:65535/IMAGES/logo.png" alt="" />
				<div class="time">{{ nowTime }}</div>
			</div>
			<el-row type="flex" style="background: linear-gradient(135deg, #ada996, #f2f2f2, #dbdbdb, #eaeaea);" :gutter="20">
				<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
					<el-card :body-style="{ padding: '0px' }" style="height: 100%;">
						<div @click="gostudys()" class="intstitle">高铁时代云学习系统</div>
						<img @click="gostudys()" class="intstitlecontent" src="../images/homeinitddd.png" />
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
					<el-card :body-style="{ padding: '0px' }">
						<div @click="gotrains()" class="intstitle">智慧实训管理平台</div>
						<img @click="gotrains()" class="intstitlecontent" src="../images/datawalldsdd.jpg" />
					</el-card>
				</el-col>

				<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
					<el-card :body-style="{ padding: '0px' }">
						<div @click="gogoldbrick()" class="intstitle">高铁时代金砖大赛系统</div>
						<img @click="gogoldbrick()" src="../images/biggame.png" class="intstitlecontent" />
					</el-card>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" style="margin: 20px 0;">
					<el-card :body-style="{ padding: '0px' }">
						<div @click="gogolznyws()" class="intstitle">智能运维平台</div>
						<img @click="gogolznyws()" src="@/assets/images/operation.png" class="intstitlecontent" />
					</el-card>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import AppOptions from '../config/AppOptions.vue';
import { getUserSingle } from '@/request/api/mange/mange.js';

export default {
	data() {
		return {
			timeID: null,
			timer: '',
			nowTime: '',
			playFlip: false
		};
	},
	mounted() {
		this.gettimers();
	},
	beforeCreate() {
		AppOptions.appEmpty = true;
	},
	created() {
		AppOptions.appEmpty = true;
	},
	beforeDestroy() {
		window.clearInterval(this.timer); //clearInterval() 方法来停止执行这个计时器
	},
	// beforeRouteLeave(to, from, next) {
	// 	AppOptions.appEmpty = false;
	// 	next();
	// },
	methods: {
		gostudys() {
			this.$router.push('/homesview/homesview');
		},
		gotrains() {
			if (localStorage.getItem('uiguid')) {
				this.gomunns();
			} else {
				this.$router.push('/user/logins');
			}
		},
		gomunns() {
			getUserSingle(localStorage.getItem('uiguid')).then(re => {
				// console.log(re, "获取当前用户")
				if (re.data.code == -1) {
					// console.log("无权限")
				} else {
					// console.log("有权限")
					let usercenter = {};
					usercenter = re.data.data;
					usercenter.ui_realName = re.data.data.ui_realName;
					usercenter.ui_photoPath = re.data.data.ui_photoPath;
					usercenter.UserMenuList = re.data.data.UserMenuList;

					window.localStorage.setItem('usercenter', JSON.stringify(usercenter));

					if (re.data.data.UserMenuList[0].path == '/usercenter') {
						this.$router.push(re.data.data.UserMenuList[0].children[0].path);
					} else {
						this.$router.push(re.data.data.UserMenuList[0].path);
					}
				}
			});
		},
		gogoldbrick() {
			// this.$router.push('/BricsContest/Index');
			window.open('https://www.hngtsd.net:8090/BricsContest/Index', 'theFrame', '', false);
			// window.location.href = 'http://www.hngtsd.net:80/#/BricsContest/Index';
			// location.href = `http://www.hngtsd.net:80/BricsContest/Index`;
			// top.location = 'http://www.hngtsd.net:80/BricsContest/Index';
		},
		gogolznyws() {
			window.open('/zhinengyunwei/#/', 'theFrame', '', false);
		},
		play() {
			this.playFlip = !this.playFlip;
		},
		gettimers() {
			//时间转换
			this.timer = setInterval(() => {
				let date = new Date();
				let year = date.getFullYear();
				/* 在日期格式中，月份是从0开始的，因此要加0
				 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				 * */
				let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
				let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
				let hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
				let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
				let seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
				// 拼接
				this.nowTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
				// return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
			}, 1000);
		}
	}
};
</script>

<style scoped lang="less">
.initers {
	height: 100%;
	padding: 0 40px;
	box-sizing: border-box;
	width: 100%;
	background: linear-gradient(135deg, #ada996, #f2f2f2, #dbdbdb, #eaeaea);
}

/deep/ .el-card__body:hover {
	opacity: 0.6;

	img {
		opacity: 0.6;
		filter: alpha(opacity=60);
	}
}

// /deep/ .el-card__body img:hover {
// 	background-color: rgba(212, 212, 212, 0.7);
// }

.intstitle {
	font-size: 1.5vw;
	padding: 20px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 10%;
	width: 100%;
}
.intstitlecontent {
	width: 100%;
	// height: 30vh;
}

.mask {
	position: absolute;
	background: rgba(101, 101, 101, 0.6);
	color: #ffffff;
	opacity: 0;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
	border-radius: 10px;
	pointer-events: none;
}

/deep/ .el-card__body {
	cursor: pointer;
	// height: 52%;
}

.flip-box {
	position: relative;
	overflow: hidden;
	height: 400px;
	width: 100%;
}

.flip-item {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	transition: all 1s ease-in-out 0s;
	backface-visibility: hidden;
	box-sizing: border-box;
}

.flip-item-front {
	z-index: 2;
	background: #f5f5f5;
	color: #000;
}

.flip-item-back {
	transform: rotateY(180deg);
	z-index: 1;
	background: green;
	color: white;
}

.flip-box:hover .flip-item-front {
	transform: rotateY(180deg);
}

.flip-box:hover .flip-item-back {
	transform: rotateY(0deg);
}

.flip-front {
	transform: rotateY(180deg);
}

.flip-back {
	transform: rotateY(0deg);
}

.initslogos {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 10px;
}

.time {
	color: #00aa00;
	font-size: 16px;
	font-weight: 700;
}

.container {
	perspective: 1000; /* 其子元素会获得透视效果，而不是元素本身。 */
}

/* 鼠标悬浮时，翻转 */
/* .container:hover .card,.container.hover .card{  
	            transform:rotateY(180deg); 
	        } */

/* 手动控制翻转 */
.container.flip .card {
	transform: rotateY(180deg);
}

.container,
.front,
.back {
	width: 320px;
	height: 480px;
}

.card {
	transition: 0.6s;
	transform-style: preserve-3d; /* 让其有3d效果 */
	position: relative;
}

.front,
.back {
	backface-visibility: hidden; /*翻转隐藏背面 */
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
}

.front {
	z-index: 2;
	background-color: cadetblue;
}

.back {
	background-color: bisque;
	transform: rotateY(180deg);
}

.back div {
	width: 100%;
}
</style>
